import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { UserRole } from 'types/role';
import { actionCreatorFactory } from 'typescript-fsa';

export const { wrapFetching, wrapSaving, withXhrStatusReducer } = createXhrStatusModule('roles');

export interface State {
  userRoles: Array<UserRole>;
  xhrStatus: XhrStatus;
}

const actionCreator = actionCreatorFactory('timely/roles');

export const fetchedRoles = actionCreator<Array<UserRole>>('FETCHED');
